import React from 'react';

import { FormikHelpers } from 'formik';
import { useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';
import { useHistory, useRouteMatch } from 'react-router-dom';

import { successAlert, errorAlert, addStation } from 'actions';
import { updateStationCodeApi } from 'app/operations/stations/station-api';
import { StationForm } from 'app/operations/stations/station-form';
import { StationFormState } from 'app/operations/stations/station-helpers';
import { trimTrailingSlash } from 'helpers/url-helpers';

const initialState: StationFormState = {
  en_name: '',
  ar_name: '',
  station_code: '',
  organisationId: '',
  enabled: false,
};

const AddStation: React.FC = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const match = useRouteMatch();
  const baseURL = trimTrailingSlash(match.url);
  const intl = useIntl();

  const handleSubmit = (
    values: StationFormState,
    { setSubmitting }: FormikHelpers<StationFormState>
  ) => {
    setSubmitting(true);

    Promise.resolve(
      dispatch(
        addStation({
          en_name: values.en_name,
          ar_name: values.ar_name,
          organisation_id: values.organisationId,
          disabled: !values.enabled,
        })
      )
    )
      .then(async ({ action }: any) => {
        const newStationId = action.payload.data?.response?.station?.id;

        if (newStationId && values.station_code) {
          try {
            await updateStationCodeApi(newStationId, values.station_code);
          } catch (err: any) {
            const message =
              err?.response?.data?.message ||
              intl.formatMessage({ id: 'stationCodeUpdateFailed' });

            dispatch(errorAlert(message));
          }
        }

        history.push(`${baseURL.replace('/new', '')}/${newStationId}`);
        dispatch(successAlert(intl.formatMessage({ id: 'successAddStation' })));
      })
      .finally(() => {
        setSubmitting(false);
      });
  };

  return <StationForm {...{ initialState, handleSubmit }} />;
};

export { AddStation };
